import { useState, useEffect } from "react";
import Header from "../header/header";
import { useGame } from "../header/GameContext";
import "./suspect.css";

function Suspect({
  suspectImgs = [],
  timerMode = "run",
  isHintMode = false,
  onFinish,
  defaultPath,
}) {
  const { startTimer, pauseTimer, openHint } = useGame();

  useEffect(() => {
    timerMode === "run" ? startTimer() : pauseTimer();
  }, [timerMode]);

  const [step, setStep] = useState(0);
  const [isFade, setIsFade] = useState(false); // ⭐ 추가

  const isLastStep = step === suspectImgs.length - 1;

  const nextStep = () => {
    if (isLastStep) {
      if (isHintMode) {
        openHint(); // ✅ 힌트모드면 LIST로 이동
        return;
      }
      onFinish &&
        onFinish({
          defaultPath,
          state: { DateVal: "intro2", titImgClass: "infoTit" },
        });
      return;
    }

    setIsFade(true);
    setTimeout(() => {
      setStep((prev) => prev + 1);
      setIsFade(false);
    }, 300);
  };

  return (
    <div className="box3 content_box1 box_storage_bg ans0001 suspect_sr">
      {!isHintMode && <Header backgroundNone0={true} />}
      {/* <Header backgroundNone0={true} /> */}

      <div
        className={`${isHintMode ? "hint_detail" : ""} box_con con_box7 con_box_storage`}
      >
        <div className="missionDivTu">
          <div className="missionDiTu">
            <div
              className={`mission_content pdTB65120 suspect_content ${isHintMode && !isLastStep ? "hintMode_content" : ""}`}
            >
              <div className="imgis img01">
                {suspectImgs[step] && (
                  <div
                    className={`imgis img0${step + 1} suspect-motion ${
                      isFade ? "fade-out" : "fade-in"
                    }`}
                  >
                    <img
                      src={suspectImgs[step]}
                      className={`suspect-card suspect-${step + 1}`}
                      alt={`suspect-${step + 1}`}
                    />
                  </div>
                )}
              </div>

              <div className="slide-dots mt20">
                {suspectImgs.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    className={`slide-dots-btn ${step === index ? "active" : ""}`}
                    onClick={() => {
                      setIsFade(true); // 1. 사라지기 시작

                      setTimeout(() => {
                        setStep(index); // 2. 선택된 dot 활성화
                        setIsFade(false); // 3. 다시 나타남
                      }, 300); // CSS 시간과 동일
                    }}
                  />
                ))}
              </div>

              <div id="box_ft3">
                <input
                  type="button"
                  className="inputBtn02"
                  value={isLastStep ? "확인" : isHintMode ? "다음으로" : "다음"}
                  onClick={nextStep}
                />
                {isHintMode && !isLastStep && (
                  <button
                    type="button"
                    className="inputBtn02 mt16"
                    onClick={openHint}
                  >
                    닫기
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Suspect;
